/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';
import {
  useSMActualDetailPage,
  useSMBlockchainProof,
  useSMTransactionList,
} from '@pages/ActualDetailPage/machines';

import {
  HeroSection,
  BackArrowComp,
  TimelineDetailModal,
  TransactionReceiptModal,
} from '../components';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer } from '@/application';
import { ActualDetailPageService } from '@pages/ActualDetailPage/services';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { useLocation } from 'react-router-dom';
import { usePolicyId } from '@pages/ActualDetailPage/provider';

const getSrv = () => {
  return vappContainer.get<ActualDetailPageService>(
    ActualDetailPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [cardModal, setCardModal] = useState<boolean>(false);
  const [receiptModal, setReceiptModal] = useState<boolean>(false);
  const [receiptData, setReceiptData] = useState<any>();
  const [cardId, setCardId] = useState<string>('');
  const { policyNumber } = usePolicyId();
  const theme = useTheme();
  const { state } = useLocation();
  const {
    actualdetailPageMachine,
    actualdetailPageState,
    actualdetailPageSend,
  } = useSMActualDetailPage({});

  const { transactionListMachine, transactionListSend, transactionListState } =
    useSMTransactionList({});

  const { blockchainProofMachine, blockchainProofSend, blockchainProofState } =
    useSMBlockchainProof({});

  const staticPageContentConfig = getSrv()?.agent?.getStaticActualDetailSync();
  const srv = getSrv();

  const onRefresh = () => {
    actualdetailPageSend('TRIGGER_REFRESH', {});
  };

  const _renderErrorNotification = () => {
    if (actualdetailPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getDetail || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (actualdetailPageState?.matches('UPDATE_KYC_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.myAccount || {})}
          onAcknowledgement={props?.onGoBack}
          onDeny={onRefresh}
        />
      );
    }
  };

  const onHeroButtonClick = (key: string) => {
    if (key === 'download') {
      document.getElementById('downloadPolicy')?.click();
    }
    if (key === 'weather') {
      props?.onWeatherClick && props?.onWeatherClick(policyNumber);
    }
  };

  const onCardClick = (id: string) => {
    console.log(`card clicked id`, id);
    blockchainProofSend('START', {
      payload: {
        ...actualdetailPageState?.event?.data?.value?.timelineData,
        cardId: id,
      },
    });

    let _cardDetail = srv?.agent?.getFormatTimeline({
      ...actualdetailPageState?.event?.data?.value?.timelineData,
      cardId: id,
    });
    if (
      Array.isArray(_cardDetail?.data?.data) &&
      _cardDetail?.data?.data?.length > 0
    ) {
      if (!cardModal) {
        setCardModal(true);
      }
      setCardId(id);
    }
  };

  const onCardClose = (id: string) => {
    if (cardModal) {
      setCardModal(!cardModal);
    }
  };
  const onTriggerModal = (data: any) => {
    console.log('Receipt modal trigger', data);
    setReceiptData(data);
    if (!receiptModal) {
      setReceiptModal(true);
    }
  };

  const onReceiptModalClose = () => {
    if (receiptModal) {
      setReceiptModal(!receiptModal);
    }
  };

  const _renderNestedModal = () => {
    console.log(`blockchain tx`, blockchainProofState?.event?.data?.value);
    if (receiptModal) {
      return (
        <TransactionReceiptModal
          showModal={receiptModal}
          modalTitle={'Transaction Receipt'}
          // data={receiptData}
          data={blockchainProofState?.event?.data?.value || {}}
          onDeny={onReceiptModalClose}
        />
      );
    }
  };

  const _renderPage = () => {
    console.log('state.detail', state?.detail);
    if (actualdetailPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    if (state.detail) {
      // let productDetail = srv?.agent?.getFormatPolicy(state?.detail);
      return (
        <>
          <HeroSection
            {...(actualdetailPageState?.event?.data?.value || {})}
            onHeroButtonClick={onHeroButtonClick}
            carouselItems={
              actualdetailPageState?.event?.data?.value?.carouselItems ?? []
            }
            timelineDetails={
              actualdetailPageState?.event?.data?.value?.timelineDetails ?? {
                listItems: [],
              }
            }
            buttons={actualdetailPageState?.event?.data?.value?.buttons}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (actualdetailPageState?.matches('RENDER_PAGE')) {
      console.log(`event data`, actualdetailPageState?.event?.data?.value);
      let _tempItems: any = [];
      if (
        Array.isArray(actualdetailPageState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ...actualdetailPageState?.event?.data?.value?.accordionItems,
        ];
      }

      // if(Array.isArray(transactionListState?.event?.data?.value?.accordionItems)){
      //   _tempItems =[..._tempItems, ...transactionListState?.event?.data?.value?.accordionItems];
      // }

      return (
        <>
          <HeroSection
            {...(actualdetailPageState?.event?.data?.value || {})}
            onHeroButtonClick={onHeroButtonClick}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (actualdetailPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    return null;
  };

  const _renderNotification = () => {
    // if (actualdetailPageState?.matches("GET_PAGE_CONTENT")) {
    //   return (
    //     <NotificationModal
    //       showModal={true}
    //       {...(staticPageContentConfig?.notifications?.revokeCredential || {})}
    //       onAcknowledgement={onRefresh}
    //       onDeny={onRefresh}
    //     />
    //   );
    // }
    return null;
  };

  const _renderHeader = () => {
    return <BackArrowComp />;
  };

  const _renderAnchorLink = () => {
    return (
      <a
        download={actualdetailPageState?.event?.data?.value?.title}
        href={actualdetailPageState?.event?.data?.value?.policyDocument}
        title="Download pdf document"
        id="downloadPolicy"
        style={{ display: 'none' }}
      />
    );
  };

  const _renderModal = () => {
    if (cardModal) {
      let _temp = srv?.agent?.getFormatTimeline({
        ...transactionListState?.event?.data?.value?.timelineData,
        cardId,
      });
      console.log(`_temp data`, _temp);
      return (
        <TimelineDetailModal
          showModal={cardModal}
          modalTitle={_temp?.title}
          data={_temp?.data}
          onDeny={onCardClose}
          onTriggerModal={onTriggerModal}
        />
      );
    }
  };

  return (
    <>
      {_renderHeader()}
      {_renderModal()}
      {_renderPage()}
      {_renderErrorNotification()}
      {_renderNotification()}
      {_renderAnchorLink()}
      {_renderNestedModal()}
    </>
  );
};
